// Danh sách hội thoại dùng chung (react-query) + số chưa đọc cho badge của mục menu "Gom Đơn".
// Nằm trong gói chính (khung menu dùng): chỉ import client.ts / access.ts / module thuần, KHÔNG import socket.ts.
// Khung menu chỉ hỏi lại mỗi phút (và khi quay lại tab); đang mở trang Gom Đơn thì trang cập nhật chính cache này
// theo socket nên badge đổi ngay.

import { useCallback } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/lib/auth'
import { gomdon } from './client'
import { gomdonKeys, useGomdonAccess } from './access'
import { unreadByKind } from './inbox-model'
import type { Conversation } from './types'

export const fetchConversations = () => gomdon.get<Conversation[]>('/conversations')

/** Badge menu: số hội thoại còn tin chưa đọc (tin nhắn + bình luận) trên mục `/inbox`; mục khác → null */
export function useGomdonNavBadge(): (to: string) => number | null {
  const access = useGomdonAccess()
  const unit = useAuth().activeShopId
  const q = useQuery({
    queryKey: gomdonKeys.conversations(unit),
    queryFn: fetchConversations,
    enabled: access.enabled,
    staleTime: 30_000,
    refetchInterval: 60_000,
    retry: false,
  })
  const counts = access.enabled ? unreadByKind(q.data, access.reviewMode) : null
  const total = counts ? counts.chat + counts.comment : 0
  return useCallback((to: string) => (to === '/inbox' ? total : null), [total])
}
